import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Does this sound like you" className="border-y border-plum/10 bg-cream" data-id="element-102" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 py-10" style={{
      paddingTop: "15px",
      paddingBottom: "20px"
    }} data-id="element-103" data-mp="26xwjuucs03mc">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-104" data-mp="2bvobrodf7pqj">
          👇 Does this sound like you?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-105" data-mp="21z32urya5uhf">
          You know how to deliver excellent work. But when a potential client asks for a proposal, suddenly you're dealing
          with a different kind of challenge. You need to understand the brief, identify what the client really needs, define
          deliverables, organize the timeline, explain your value, and present everything professionally — while managing
          your actual freelance work.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-plum" data-id="element-106" data-mp="1yzvl3o3bazx3">
          The problem isn't necessarily your expertise. It's the lack of a{' '}
          <span className="text-grape" data-id="element-107" data-mp="27sz0i1xipmud">repeatable proposal-building framework</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-108" data-mp="23rdglwmkg8ao">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-plum/10 bg-white p-5" data-id="element-109" data-mp="23trcu8szfqjt" data-mpi={i}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-plum text-sm" aria-hidden="true" data-id="element-110" data-mp="1k1upywa9cs40">
                {p.emoji}
              </span>
              <div data-id="element-111" data-mp="2vhjfnvewc58i">
                <h3 className="text-sm font-bold uppercase tracking-wide text-plum" data-id="element-112" data-mp="2vi1lnjrd1xtm">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-113" data-mp="1t4n3yi4jz1ab">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-10 text-center font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-114" data-mp="22634zz9h9r1v">
          ✨ If you recognize these challenges, <span className="text-grape" data-id="element-115" data-mp="273v9dsrb75my">SIGMA SMART™</span> has a practical solution for you.
        </p>
      </div>
    </section>;
}